import { SchuelerEnv } from '../../env/SchuelerEnv';
import { Store } from './Store';

export class SchuelerStore {
  readonly nextStore: Store;

  constructor(nextStore) {
    this.nextStore = nextStore;
    if (typeof window !== 'undefined') {
      (window as any).schuelerStore = this;
    }
  }

  get schuelerData() {
    return this.nextStore.appComponent.props.schuelerData as SchuelerEnv['schuelerData'];
  }

  get gruppenmitglied() {
    return this.schuelerData.gruppenmitglied;
  }

  get gruppenmitglieder() {
    return this.schuelerData.gruppenmitglieder;
  }

  get gruppe() {
    return this.schuelerData.gruppe;
  }

  get lehrer() {
    return this.schuelerData.lehrer;
  }

  // @observable test = 1;
}
